<template>
  <div class="wrapper">
    <div
      v-if="userProfile.type !== 'admin-access'"
      class="container-fluid dashboard-body"
    >
      <div class="col" style="padding: 0" id="minhadiv">
        <div class="row no-gutters">
          <div class="col-12">
            <dashboard-bar refreshButton>
              <!-- <template slot="export-pdf">
                <div style="padding-left: 15px;">
                  <span>
                    <i
                      style="color:#4ce595;cursor:pointer;font-size:18px;"
                      class="fas fa-file-pdf"
                      title="Exportar para PDF"
                      @click="exportPDF"
                    ></i>
                  </span>
                </div>
              </template>-->
              <template slot="dashboard-items">
                <div>
                  <strong>{{ $t('dashboard.invites') }}</strong>
                  <br />
                  <span style="position: relative">
                    <b-skeleton v-if="invitesRequest"></b-skeleton>
                    <span v-else>
                      {{ amountInvites === 0 ? '-' : amountInvites }}
                    </span>
                  </span>
                </div>
                <!-- <div>
                  <strong>{{ $t('dashboard.customers') }}</strong>
                  <br />
                  <span style="position: relative;">
                    <loader v-if="clientsRequest" />
                    <animated-number
                      v-else
                      :value="amountClients"
                      :formatValue="formatToPrice"
                      :duration="1500"
                    />
                  </span>
                </div> -->
                <div>
                  <strong>{{ $t('dashboard.answers') }}</strong>
                  <br />
                  <span style="position: relative">
                    <b-skeleton v-if="answersRequest"></b-skeleton>
                    <span v-else>
                      {{ amountAnswers === 0 ? '-' : amountAnswers }}
                    </span>
                  </span>
                </div>
                <div
                  v-if="
                    companyId == '5e18ccd0dc36a60022491bdf' ||
                    companyId == '61965aa04be7ea63c8f83435'
                  "
                >
                  <strong>{{ $t('dashboard.digitalResponseDate') }}</strong>
                  <br />
                  <span>
                    <b-skeleton v-if="invitesRequest"></b-skeleton>
                    <span v-else>
                      {{
                        isNaN(computedDigitalTx)
                          ? '-'
                          : computedDigitalTx.toFixed(1) + '%'
                      }}
                    </span>
                  </span>
                </div>
                <div>
                  <strong
                    v-if="
                      companyId == '5e18ccd0dc36a60022491bdf' ||
                      companyId == '61965aa04be7ea63c8f83435'
                    "
                  >
                    {{ $t('dashboard.totalResponseRate') }}
                  </strong>
                  <strong v-else>{{ $t('dashboard.responsesRate') }}</strong>
                  <br />
                  <span>
                    <span v-if="invitesRequest">
                      <b-skeleton></b-skeleton>
                    </span>
                    <span v-else>
                      {{
                        isNaN(
                          ((amountAnswers / amountInvites) * 100).toFixed(1),
                        ) &&
                        amountAnswers === 0 ||
                        amountInvites === 0
                          ? '-'
                          : ((amountAnswers / amountInvites) * 100).toFixed(1) +
                            '%'
                      }}
                    </span>
                  </span>
                </div>
              </template>
            </dashboard-bar>
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col-3">
            <nps-bar />
          </div>
          <div class="col-4">
            <horizontal-bar />
          </div>
          <div class="col-5">
            <vertical-column />
          </div>
        </div>
        <div
          class="row no-gutters"
          v-if="npsPonderData && npsPonderData.length"
        >
          <div class="col-12">
            <nps-ponder
              :showCollapsed="true"
              :npsPonderData="npsPonderData"
              :weightedNpsType="weightedNpsType"
            />
          </div>
        </div>
        <div class="row no-gutters" v-if="visibleCCSI">
          <div class="col-12">
            <ccsi :showCollapsed="true" />
          </div>
        </div>
        <div class="row no-gutters" v-if="visibleHGSI">
          <div class="col-12">
            <hgsi :showCollapsed="true" />
          </div>
        </div>
        <div class="row no-gutters" v-if="visiblePHGSI">
          <div class="col-12">
            <prehgsi :showCollapsed="true" />
          </div>
        </div>
        <div class="row no-gutters" v-if="visibleFCSI">
          <div class="col-12">
            <fcsi :showCollapsed="true" />
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col-3">
            <div v-if="isLoading">
              <div class="idx-card">
                <idx-skeleton width="150" height="30" radius="0" class="m-2" />
                <idx-skeleton width="190" height="15" radius="0" class="m-2" />
                <br />
                <idx-skeleton width="50" height="30" radius="0" class="ml-2" />
              </div>
            </div>
            <div v-else>
              <card-item
                title="SMS"
                :subtitle="`${$t(
                  'menu.settings.accountData.labels.collectionChannel',
                )}`"
                icon="mobile-alt"
                :volume="answersByPhone.total"
                :percentil="answersByPhone.percentil"
              />
            </div>
          </div>
          <div class="col-3">
            <div v-if="isLoading">
              <div class="idx-card">
                <idx-skeleton width="150" height="30" radius="0" class="m-2" />
                <idx-skeleton width="190" height="15" radius="0" class="m-2" />
                <br />
                <idx-skeleton width="50" height="30" radius="0" class="ml-2" />
              </div>
            </div>
            <div v-else>
              <card-item
                title="E-mail"
                :subtitle="`${$t(
                  'menu.settings.accountData.labels.collectionChannel',
                )}`"
                icon="envelope-open-text"
                :volume="answersByEmail.total"
                :percentil="answersByEmail.percentil"
              />
            </div>
          </div>
          <div class="col-3">
            <div v-if="isLoading">
              <div class="idx-card">
                <idx-skeleton width="150" height="30" radius="0" class="m-2" />
                <idx-skeleton width="190" height="15" radius="0" class="m-2" />
                <br />
                <idx-skeleton width="50" height="30" radius="0" class="ml-2" />
              </div>
            </div>
            <div v-else>
              <card-item
                title="Manual"
                :subtitle="`${$t(
                  'menu.settings.accountData.labels.collectionChannel',
                )}`"
                icon="edit"
                :volume="answersByManual.total"
                :percentil="answersByManual.percentil"
              />
            </div>
          </div>
          <div class="col-3">
            <div v-if="isLoading">
              <div class="idx-card">
                <idx-skeleton width="150" height="30" radius="0" class="m-2" />
                <idx-skeleton width="190" height="15" radius="0" class="m-2" />
                <br />
                <idx-skeleton width="50" height="30" radius="0" class="ml-2" />
              </div>
            </div>
            <div v-else>
              <card-item
                :title="`${this.othersTitle}`"
                :subtitle="`${$t(
                  'menu.settings.accountData.labels.collectionChannel',
                )}`"
                icon="comment-dots"
                :volume="answersByLinkWppWppWidgetQrCode.total"
                :percentil="answersByLinkWppWppWidgetQrCode.percentil"
              />
            </div>
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col-12">
            <div class="table-actions-area">
              <div>
                <button
                  @click="handleCollapsed"
                  class="btn"
                  style="box-shadow: none"
                >
                  <i class="fab fa-buffer"></i>
                  {{ $t('dashboard.stockComparison') }}
                </button>
                <button
                  @click="handleCollapsed"
                  class="btn pull-right"
                  style="box-shadow: none"
                >
                  <i class="fas fa-angle-double-right" v-if="!visible"></i>
                  <i v-else class="fas fa-angle-double-down"></i>
                </button>
              </div>
              <div>
                <b-collapse v-model="visible" class="mt-2">
                  <comparative-actions v-if="visible" />
                </b-collapse>
              </div>
            </div>
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col-12">
            <likeDislike :showCollapsed="true" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import html2canvas from 'html2canvas';
import JsPDF from 'jspdf';
import npsBar from '@/components/molecules/nps-bar';
import horizontalBar from '@/components/molecules/highcharts/horizontal-bar';
import verticalColumn from '@/components/molecules/highcharts/vertical-column';
import dashboardBar from '@/components/molecules/dashboard-bar';
import comparativeActions from '@/components/molecules/comparative-actions';
import cardItem from '@/components/molecules/card-items';
import animatedNumber from 'animated-number-vue';
import loader from '@/components/atoms/loader';
import likeDislike from '@/components/molecules/highcharts/reports/rankings/components/like-dislike';
import ccsi from '@/components/molecules/highcharts/reports/rankings/components/ccsi';
import hgsi from '@/components/molecules/highcharts/reports/rankings/components/hgsi';
import prehgsi from '@/components/molecules/highcharts/reports/rankings/components/prehgsi';
import fcsi from '@/components/molecules/highcharts/reports/rankings/components/fcsi';
import npsPonder from '@/components/molecules/highcharts/reports/nps-ponder';
import api from '@/services/api';
import idxSkeleton from '@/components/molecules/idx-skeleton';
import EventBus from '../../../eventBus';

export default {
  name: 'Dashboard',
  components: {
    npsBar,
    horizontalBar,
    verticalColumn,
    dashboardBar,
    cardItem,
    animatedNumber,
    comparativeActions,
    likeDislike,
    ccsi,
    hgsi,
    prehgsi,
    fcsi,
    loader,
    npsPonder,
    idxSkeleton,
  },
  data: () => ({
    userAuth: null,
    answersRequest: false,
    clientsRequest: false,
    invitesRequest: false,
    visible: false,
    visibleLD: false,
    visibleCCSI: true,
    visibleHGSI: true,
    visiblePHGSI: true,
    visibleFCSI: true,
    companyId: null,
    othersTitle: '',
    npsPonderData: null,
    weightedNpsType: 'actions',
    isLoading: false,
  }),
  watch: {
    actionGroupData: async function watchActionGroup() {
      // await this.getDashboardData();
    },

    myActionId: async function watchMyActionId() {
      // await this.getDashboardData();
    },
    myActionsIds: async function watchMyActionId() {
      await this.getDashboardData();
    },
    myIh1: async function watchMyIh1() {
      // await this.getDashboardData();
    },
    myIh2: async function watchMyIh2() {
      // await this.getDashboardData();
    },
    calendarDates: async function watchDates() {
      await this.getDashboardData();
    },
    myMetric: async function watchMyMetric() {
      await this.getDashboardData();
    },
    'indicatorData.value': async function watchIndicatorData() {
      // await this.getDashboardData();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      // await this.getDashboardData();
    },
  },
  computed: {
    ...mapState('dashboard', [
      'answersByPhone',
      'answersByEmail',
      'answersByManual',
      'answersByLinkWppWppWidgetQrCode',
      'amountAnswers',
      'amountClients',
      'amountInvites',
    ]),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('authentication', ['userProfile']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric', 'company']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
    computedDigitalTx() {
      return (
        100 *
        ((this.amountAnswers - this.answersByManual.total) / this.amountInvites)
      );
    },
  },
  methods: {
    ...mapActions('dashboard', [
      'setAnswersByChannel',
      'setAmountAnswers',
      'setAmountClients',
      'setAmountInvites',
    ]),
    ...mapActions('calendar', ['setDefaultDates']),
    ...mapActions('actions', [
      'getAllActions',
    ]),

    async getDashboardData() {
      this.isLoading = true;
      this.answersRequest = true;
      this.clientsRequest = true;
      this.invitesRequest = true;

        this.setAnswersByChannel({
          companyId: this.userAuth.companyId,
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          token: this.userAuth.token,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          startDate: this.calendarDates.start ? this.calendarDates.start : null,
          endDate: this.calendarDates.end ? this.calendarDates.end : null,
          metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
        }).then(()=>{
          this.isLoading = false;
        })

        this.setAmountAnswers({
          companyId: this.userAuth.companyId,
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          token: this.userAuth.token,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          startDate: this.calendarDates.start ? this.calendarDates.start : null,
          endDate: this.calendarDates.end ? this.calendarDates.end : null,
          metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
        }).then(()=>{
          this.answersRequest = false;
        })

        // this.setAmountClients({
        //   companyId: this.userAuth.companyId,
        //   actionId: this.myActionId !== '0' ? this.myActionId : null,
        //   token: this.userAuth.token,
        //   ih1: this.myIh1 === '0' ? null : this.myIh1,
        //   ih2: this.myIh2 === '0' ? null : this.myIh2,
        //   startDate: this.calendarDates.start ? this.calendarDates.start : null,
        //   endDate: this.calendarDates.end ? this.calendarDates.end : null,
        //   metric: this.myMetric ? this.myMetric : null,
        //   groupId: this.actionGroupData._id,
        //   indicator: this.indicatorName,
        //   indicatorValue: this.indicatorData.value,
        // }),

        this.setAmountInvites({
          companyId: this.userAuth.companyId,
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          token: this.userAuth.token,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          startDate: this.calendarDates.start ? this.calendarDates.start : null,
          endDate: this.calendarDates.end ? this.calendarDates.end : null,
          metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
        }).then(()=>{
          this.invitesRequest = false;
        })

        this.loadNpsPonder();

      this.clientsRequest = false;
    },

    async loadNpsPonder() {
      this.npsPonderData = null;
      // ponderado por grupo de ações
      const groupIds = ['6123fa27928bdb236c14e64d', '6123e7a58b020323491f09b8', '628bb841f0d0f37b9cb53edb', '61448c0d338e09760a650b67'];
       // ponderado por indicadores
      const indicatorsGroupIds = ['615dae35c4ac050cf1fbed66', '6217aeaf0c96c3089b56355a', '629f578c25f6c97b3384f024'];

      if (this.company.npsPonder &&
        (groupIds.includes(this.actionGroupData._id) ||
        (indicatorsGroupIds.includes(this.actionGroupData._id) && this.myActionsIds.length === 0) ||
        (this.myActionsIds.length > 0 && this.myActionsIds.includes('60fabccfc303c44729281c5e')))) {
        if (groupIds.includes(this.actionGroupData._id)) {
          this.weightedNpsType = 'actions'
        } else {
          this.weightedNpsType = 'indicators'
        }
        const response = await api.get(
          `reports/nps-ponder/${this.userAuth.companyId}`,
          {
            headers: { 'x-access-token': this.userAuth.token },
            params: {
              companyId: this.userAuth.companyId,
              actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
              startDate: this.calendarDates.start
                ? this.calendarDates.start
                : null,
              endDate: this.calendarDates.end ? this.calendarDates.end : null,
              ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
              ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
              metric: this.myMetric ? this.myMetric : null,
              groupId: this.actionGroupData._id,
              indicator: this.indicatorName,
              indicatorValue: this.indicatorData.value
                ? this.indicatorData.value
                : null,
              indicatorRange: this.indicatorData.range
                ? this.indicatorData.range
                : null,
            },
          },
        );

        this.npsPonderData = response.data.data;
      }
    },

    handleCollapsed() {
      this.visible = !this.visible;
    },
    handleCollapsedCCSI() {
      this.visibleCCSI = !this.visibleCCSI;
    },
    handleCollapsedHGSI() {
      this.visibleHGSI = !this.visibleHGSI;
    },
    handleCollapsedPHGSI() {
      this.visiblePHGSI = !this.visiblePHGSI;
    },
    handleCollapsedFCSI() {
      this.visibleFCSI = !this.visibleFCSI;
    },

    formatToPrice(value) {
      return value.toFixed(0);
    },

    formatRate(value) {
      return value.toFixed(1);
    },

    exportPDF() {
      html2canvas(document.getElementById('minhadiv'), { logging: false }).then(
        (canvas) => {
          const img = canvas.toDataURL('image/png');
          const doc = new JsPDF({
            orientation: 'landscape',
            unit: 'px',
            format: [1280, 720],
          });
          const width = doc.internal.pageSize.getWidth();

          doc.addImage(img, 'JPEG', 0, 0, width, 350);
          doc.save('RelatorioNPS.pdf');
        },
      );
    },

    loadJivoChat() {
      const hasScript = document.getElementById('jivochat-indecx');

      if (hasScript) {
        const jdiv = document.getElementsByTagName('jdiv')[0];
        jdiv.style.display = 'block';
        return;
      }

      const scriptTag = document.getElementsByTagName('script')[0];
      const e = document.createElement('script');
      e.id = 'jivochat-indecx';
      e.src = 'https://code-sa1.jivosite.com/widget/FZKk0LTEMM';
      e.type = 'text/javascript';
      e.async = true;

      scriptTag.parentNode.insertBefore(e, scriptTag);
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.companyId = this.userAuth.companyId;

    if (
      this.companyId === '5e18ccd0dc36a60022491bdf' ||
      this.companyId === '61965aa04be7ea63c8f83435' ||
      this.companyId === '5eea25739b8df13f10e8da40'
    ) {
      this.loadJivoChat();
      this.othersTitle = 'Whatsapp';
    } else {
      this.othersTitle = this.$t('menu.settings.accountData.labels.others');
    }
  },

  mounted() {
    // CAOA CHERY shows CCSI report
    if (this.companyId === '610714d424278234e7bdae99') {
      this.visibleCCSI = true;
    } else {
      this.visibleCCSI = false;
    }
    // CAOA SUBARU and Hyundai shows HGSI report
    // Subaru (6107163db7c09a18a2663385) now is SCSI
    if (
      this.companyId === '6107163db7c09a18a2663385' ||
      this.companyId === '5f69ee75a3024a4fa2416b1f'
    ) {
      this.visibleHGSI = true;
    } else {
      this.visibleHGSI = false;
    }
    // CAOA HMB shows PRE-HGSI report
    if (this.companyId === '6107f837f50c776b205ebf48') {
      this.visiblePHGSI = true;
    } else {
      this.visiblePHGSI = false;
    }
    // CAOA FORD shows FCSI report
    if (this.companyId === '6107159a24278234e7bdaea3') {
      this.visibleFCSI = true;
    } else {
      this.visibleFCSI = false;
    }

    EventBus.$on('refresh', async () => {
      this.getDashboardData();
    });
    EventBus.$on('changedLanguage', () => {
      if (
        this.companyId === '5e18ccd0dc36a60022491bdf' ||
        this.companyId === '61965aa04be7ea63c8f83435'
      ) {
        this.othersTitle = 'Whatsapp';
      } else {
        this.othersTitle = this.$t('menu.settings.accountData.labels.others');
      }
    });

    EventBus.$on('apply-filter-menu', () => {
      this.getDashboardData();
    });
    EventBus.$on('reset-filter-menu', () => {
      this.getDashboardData();
    });

    this.loadNpsPonder();
  },

  beforeDestroy() {
    EventBus.$off('refresh');
    EventBus.$off('apply-filter-menu');
    EventBus.$off('reset-filter-menu');

    const jdiv = document.getElementsByTagName('jdiv')[0];

    if (jdiv) {
      jdiv.style.display = 'none';
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
@import '@/themes/default/placeholders.scss';
@import '@/themes/default/mixins.scss';
.idx-card {
  margin-top: 16px;
  background-color: $white;
  border-radius: 4px;
  border: 1px solid $gray-light;
  width: 100%;
  height: 169px;
  padding: 8px;
  color: $title-color;

  > div {
    height: 100%;
  }
  .card-icon {
    width: 70px;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .cart-title {
    width: calc(100% - 70px);
    height: 70px;
    display: flex;
    flex-direction: column;
    padding: 8px;
    align-items: left;
    justify-content: center;
    h4 {
      margin: 0;
      padding: 0;
      font-weight: 400;
    }
    small {
      margin: 0;
      padding: 0;
      font-weight: 100;
    }
  }
  .card-value {
    width: 120px;
    padding: 8px;
    font-size: 1.5em;
    height: calc(169px - 89px);
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 100;
  }
  .chart-card {
    width: calc(100% - 120px);
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    height: calc(169px - 89px);
    padding: 16px;
  }
}
.wrapper {
  width: 100%;
  .dashboard-body {
    // @include bg-color($white);
    @each $i in $directions {
      @extend %half-padding-#{$i};
    }
  }

  .table-actions-area {
    margin-top: 16px;
    background-color: $white;
    border-radius: 4px;
    border: 1px solid $gray-light;
    width: 100%;
    padding: 16px 20px;
  }
}
</style>

<style>
.table-actions-area .btn .btn-light .collapsed {
  background-color: transparent;
}
.scoreTh,
.totalTh {
  width: 70px;
  padding-right: 0px !important;
}
.progressTh {
  font-size: 0;
  width: 10%;
  padding-right: 0px !important;
  padding-left: 0px !important;
}
.px-2 {
  padding: 1rem !important;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/dashboard/index.vue